import React from "react";

const Pill = ({ type, prefixe, onClick, text }) => {
    return (
        <div
        >
            <button className={`pill-${type}`}
                onClick={onClick}
                style={{
                    "cursor": onClick ? "pointer" : "default"
                }}>
                {
                    prefixe ?
                        <p><span>{prefixe}</span>{text ? text : null}</p>
                        :
                        <p>{text ? text : null}</p>
                }

            </button>

        </div>
    );
};

export default Pill;
